import { Linkedin } from "lucide-react";

/* Paste the real profile URLs here and the buttons appear. They stay hidden until then — a dead
   link on the one block that exists to prove a real person is worse than no link. */
const LINKEDIN = "";
const X_PROFILE = "";

/* Who built this, on the page, above the fold. Cold visitors from paid social have no reason to
   trust a logo; they have a reason to trust an operator who had the problem. */
export const FounderBlock = () => (
  <div
    data-testid="founder-block"
    className="mt-7 flex gap-4 rounded-xl border border-white/10 bg-white/[0.04] p-4 sm:p-5"
  >
    <img
      src="/brand/founder.jpg"
      alt="Jake Coates, owner-operator of Priority House Cleaning LLC"
      data-testid="founder-photo"
      className="h-16 w-16 shrink-0 rounded-lg object-cover object-[55%_38%] sm:h-20 sm:w-20"
    />
    <div className="min-w-0">
      <p className="font-display text-sm font-semibold text-white sm:text-base">Jake Coates</p>
      <p className="text-[11px] uppercase tracking-[0.16em] text-gold">
        Owner-Operator · Priority House Cleaning LLC
      </p>
      <p className="mt-2 text-xs leading-relaxed text-blue-100/75 sm:text-sm">
        I'm a property-service operator on the Outer Banks. I needed this tool, couldn't find it,
        so I built it. Cornerstone Ops runs Priority House Cleaning every turnover day — every
        feature here exists because my own operation needed it first.
      </p>
      {(LINKEDIN || X_PROFILE) && (
        <div className="mt-3 flex items-center gap-3">
          {LINKEDIN && (
            <a
              href={LINKEDIN}
              target="_blank"
              rel="noreferrer"
              data-testid="founder-linkedin"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-100/80 transition-colors duration-200 hover:text-gold"
            >
              <Linkedin className="h-3.5 w-3.5" /> LinkedIn
            </a>
          )}
          {X_PROFILE && (
            <a
              href={X_PROFILE}
              target="_blank"
              rel="noreferrer"
              data-testid="founder-x"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-100/80 transition-colors duration-200 hover:text-gold"
            >
              <span className="font-display text-sm leading-none">X</span> Profile
            </a>
          )}
        </div>
      )}
    </div>
  </div>
);
